<template>
  <div class="topUpWay">
    <md-field>
      <md-cell-item
        :title="$t('topUpAdminCardTitle')"
        arrow
        @click="$router.push({name: 'TopUpAdmin'})"
      >
        <span slot="left" class="holder">
          <svg-icon name="avatar" />
        </span>
      </md-cell-item>
    </md-field>
  </div>
</template>

<script>
import { Field, CellItem, Switch } from 'mand-mobile'

export default {
  name: 'TopUpWay',
  components: {
    [Field.name]: Field,
    [CellItem.name]: CellItem,
    [Switch.name]: Switch
  }
}
</script>

<style lang="scss" scoped>
.holder { /* stylelint-disable declaration-block-no-duplicate-properties, selector-pseudo-element-no-unknown */
  display: block;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: #e6e6e6;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  .svg-icon {
    width: 80px;
    height: 80px;
  }
}

.topUpWay {
  margin-top: 40px;
  border-radius: 32px;
  box-shadow: 0 8px 32px 0 rgba(138, 149, 158, 0.2);
}

.md-field {
  padding: 0 24px;
  font-weight: 500;
  color: #333;
  height: 156px;
  border-radius: 32px;
  box-shadow: 0 4px 16px 0 rgba(138, 149, 158, 0.2);
}
// ::v-deep
::v-deep .md-cell-item-body {
  height: 156px;
}
// ::v-deep
::v-deep .md-cell-item-body::before {
  border-bottom: 0;
}

::v-deep .md-cell-item-brief {
  font-size: 32px;
  color: #333;
  font-weight: 400;
}
/* stylelint-enable */
</style>
